import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right-big",
  "use": "arrow-right-big-usage",
  "viewBox": "0 0 20 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 18\" id=\"arrow-right-big\"><path d=\"M11 17.74a1 1 0 01-.29 0 .75.75 0 01-.46-.7V13.7H1a.76.76 0 01-.74-.7V5A.76.76 0 011 4.2h9.25V1.01a.74.74 0 01.47-.69.72.72 0 01.81.16l8 8a.75.75 0 010 1.06l-8 8a.71.71 0 01-.53.2zM1.76 12.2H11a.76.76 0 01.75.75v2.23L17.93 9l-6.18-6.17V5a.77.77 0 01-.22.53.75.75 0 01-.53.17H1.76v6.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol